import { TableColumn } from '@silverfort/sf-components';
import { Application } from '../../../../types/Application';
import { ApplicationNameCell } from '../components/ApplicationNameCell';
import { useMemo } from 'react';
import { DateFormat, formatDate } from '../../../../../../utils/dates';

export const useColumns = (onApplicationClick: (appId: string) => void) => {
    return useMemo<Array<TableColumn<Application>>>(
        () => [
            {
                columnKey: 'name',
                render: (app) => <ApplicationNameCell app={app} onClick={onApplicationClick} />,
                title: 'Application'
            },
            { columnKey: 'total_resources', title: 'Resources' },
            { columnKey: 'total_identities', title: 'Users' },
            {
                columnKey: 'last_access',
                title: 'Last login',
                render: ({ last_access }) =>
                    last_access ? formatDate(last_access, DateFormat.SHORT_DATE_MD, true) : 'N/A'
            }
        ],
        [onApplicationClick]
    );
};
